'use client';

import { c as _c } from "react/compiler-runtime";
import { Button } from '@algoacademy/design-system/web/actions/Button';
import { H4 } from '@algoacademy/design-system/web/marketing/typography/Heading/H4';
import { P3 } from '@algoacademy/design-system/web/marketing/typography/Paragraph';
import { ChevronLeftIcon, ChevronRightIcon } from '@heroicons/react/20/solid';
import { format, isBefore } from 'date-fns';
import { pl } from 'date-fns/locale';
type CalendarHeaderProps = {
  selectedDaySlot: Date;
  handleNextDay: () => void;
  handlePrevDay: () => void;
};
export function CalendarHeader(t0) {
  const $ = _c(39);
  const {
    selectedDaySlot,
    handleNextDay,
    handlePrevDay
  } = t0;
  let t1;
  if ($[0] !== selectedDaySlot) {
    t1 = format(selectedDaySlot, "dd MMMM", {
      locale: pl
    });
    $[0] = selectedDaySlot;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const dayAndMonthName = t1;
  let t2;
  if ($[2] !== selectedDaySlot) {
    t2 = format(selectedDaySlot, "EEEE", {
      locale: pl
    }).charAt(0).toUpperCase();
    $[2] = selectedDaySlot;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== selectedDaySlot) {
    t3 = format(selectedDaySlot, "EEEE", {
      locale: pl
    }).slice(1);
    $[4] = selectedDaySlot;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const weekDayName = t2 + t3;
  let t4;
  if ($[6] !== selectedDaySlot) {
    t4 = format(selectedDaySlot, "dd.MM.yyyy");
    $[6] = selectedDaySlot;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const fullDate = t4;
  let t5;
  if ($[8] !== fullDate) {
    t5 = <time dateTime="2022-01-22" className="font-semibold text-slate-900 sm:hidden"><H4>{fullDate}</H4></time>;
    $[8] = fullDate;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== dayAndMonthName) {
    t6 = <time dateTime="2022-01-22" className="hidden sm:inline"><H4>{dayAndMonthName}</H4></time>;
    $[10] = dayAndMonthName;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== weekDayName) {
    t7 = <P3>{weekDayName}</P3>;
    $[12] = weekDayName;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t5 || $[15] !== t6 || $[16] !== t7) {
    t8 = <div className="space-y-2">{t5}{t6}{t7}</div>;
    $[14] = t5;
    $[15] = t6;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== selectedDaySlot) {
    t9 = isBefore(selectedDaySlot, new Date());
    $[18] = selectedDaySlot;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <ChevronLeftIcon className="size-6" aria-hidden="true" />;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== handlePrevDay || $[22] !== t9) {
    t11 = <Button plain={true} type="button" onClick={handlePrevDay} disabled={t9}>{t10}</Button>;
    $[21] = handlePrevDay;
    $[22] = t9;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  let t12;
  if ($[24] !== selectedDaySlot) {
    t12 = format(selectedDaySlot, "dd.MM.yyyy");
    $[24] = selectedDaySlot;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  let t13;
  if ($[26] !== t12) {
    t13 = <span className="hidden font-semibold text-base text-slate-900 sm:block">{t12}</span>;
    $[26] = t12;
    $[27] = t13;
  } else {
    t13 = $[27];
  }
  let t14;
  if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <span className="relative -mx-px h-5 w-px bg-slate-300 sm:hidden" />;
    $[28] = t14;
  } else {
    t14 = $[28];
  }
  let t15;
  if ($[29] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <ChevronRightIcon className="size-6" aria-hidden="true" />;
    $[29] = t15;
  } else {
    t15 = $[29];
  }
  let t16;
  if ($[30] !== handleNextDay) {
    t16 = <Button plain={true} type="button" onClick={handleNextDay}>{t15}</Button>;
    $[30] = handleNextDay;
    $[31] = t16;
  } else {
    t16 = $[31];
  }
  let t17;
  if ($[32] !== t11 || $[33] !== t13 || $[34] !== t16) {
    t17 = <div className="flex flex-row items-center gap-3 rounded-md border border-slate-200 bg-white px-1 py-1">{t11}{t13}{t14}{t16}</div>;
    $[32] = t11;
    $[33] = t13;
    $[34] = t16;
    $[35] = t17;
  } else {
    t17 = $[35];
  }
  let t18;
  if ($[36] !== t17 || $[37] !== t8) {
    t18 = <header className="flex flex-wrap items-center justify-between gap-4 rounded-t-lg border border-slate-200 bg-slate-100 p-6 sm:flex-row">{t8}{t17}</header>;
    $[36] = t17;
    $[37] = t8;
    $[38] = t18;
  } else {
    t18 = $[38];
  }
  return t18;
}